import React, {useState, useRef} from "react";
import { GridColumn } from "@progress/kendo-react-grid";
import {PagedDataGrid} from "../../../../components/base/DataGrid/PagedDataGrid.jsx";
import {useApi} from "../../../../hooks/useApi.jsx";
import {DateCell} from "../../../../components/base/DataGrid/Cells/DateCell.jsx";
import {CheckmarkCell} from "../../../../components/base/DataGrid/Cells/CheckmarkCell.jsx";
import {YesNoCell} from "../../../../components/base/DataGrid/Cells/YesNoCell.jsx";
import {LinkCell} from "../../../../components/base/DataGrid/Cells/LinkCell.jsx";
import {AppPath} from "../../../../Router/AppRouter.jsx";
import {LongTextCell} from "../../../../components/base/DataGrid/Cells/LongTextCell.jsx";
import {CenteredHeaderCell} from "../../../../components/base/DataGrid/Cells/CenteredHeaderCell.jsx";
import {ShowcaseLayout} from "../../layout/ShowcaseLayout.jsx";

const TestDataGrid = () => {
    const gridRef = useRef();
    const {api, callApi} = useApi();
    const [pagedData, setPagedData] = useState();

    const handlePageInfoChange = async (pageInfo) => {
        await callApi({
            request: async () => {
                setPagedData(await api.getShipmentHistory(pageInfo.pageIndex, pageInfo.pageSize, "", pageInfo.sort));
            }
        });
    };

    return (
        <ShowcaseLayout>
            <PagedDataGrid
                data={pagedData}
                onPageInfoChange={handlePageInfoChange}
            >
                <GridColumn field="bolNumber" title="BOL Number" />
                <GridColumn
                    field={"bolNumber"}
                    title={"BOL Link"}
                    cells={{
                        data: (props) => LinkCell({href: AppPath.about, ...props})
                    }}
                />
                <GridColumn field="bolDate" title="BOL Date" cells={{data: DateCell}} />
                <GridColumn field="isBlind" title="Blind" cells={{data: (props) => YesNoCell({invertColor: true, ...props})}} />
                <GridColumn field="isHazmat" title="Hazardous" cells={{data: (props) => YesNoCell({invertColor: true, ...props})}} />
                <GridColumn field="equipmentType" title="Equipment Type" cells={{data: LongTextCell}} />
                <GridColumn field="isPaid" title="Paid" cells={{headerCell: CenteredHeaderCell, data: CheckmarkCell}} width={80} />
            </PagedDataGrid>
        </ShowcaseLayout>
    );
};

export default TestDataGrid;